import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import { PageDisplayer } from '../../../../ui'
import { ApplicationDetail, useAppContext } from '../../../../features/application-detail'
import { ERROR_CODES } from '../../../../features/applications/constants/error.constants'

export const ApplicationDetailPage = () => {
  const { appId } = useParams()
  const { formatMessage } = useIntl()
  const { getApplication, error } = useAppContext()
  const navigate = useNavigate()
  const location = useLocation()

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getApplication(appId)
      .then(() => setLoading(false))
      .catch(() => setLoading(false))
  }, [appId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    // Use location.state to get the previous search params if available
    const prevSearch = location.state?.prevSearch || ''
    navigate('/applications' + prevSearch)
  }

  return (
    <PageDisplayer
      loading={loading}
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.application.detail.return' })}
    >
      {error ? (
        ERROR_CODES.no_zeus_code_provided.code === error.code ? (
          formatMessage({ id: ERROR_CODES.no_zeus_code_provided.label })
        ) : (
          formatMessage({ id: 'pages.application.detail.error' }, { appId })
        )
      ) : (
        <ApplicationDetail />
      )}
    </PageDisplayer>
  )
}
